import { config } from '../config';
import { getHeaders } from './getHeaders';

export const getLeadPdf = (opportunityId: string) =>
  fetch(`${config.apiBaseUrl}/api/v2/opportunities/${opportunityId}/lead-pdf`, {
    headers: getHeaders(),
  });
